//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import { Cubic, TweenMax } from "gsap"

import SVGLoader from "../../../UI/SVGLoader"

import {
  ContentContainer,
  Titles,
  TitleText,
  TitleDescription,
  Midground,
  Background,
  Foreground
} from "./UI"

import sweepForeground from "./sweepForeground.svg"
import sweepMidground from "./sweepMidground.svg"
import sweepBackground from "./sweepBackground.svg"

type Props = {}

class SweepView extends React.Component<Props> {
  introText: HTMLElement[]
  background: ?HTMLElement
  midground: ?HTMLElement
  foreground: ?HTMLElement
  container: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.introText = []
    this.container = null
    this.background = null
    this.foreground = null
    this.midground = null
  }

  componentDidMount() {
    this.showIntroText()
    this.showScene()
  }

  showIntroText = () => {
    const intro = this.introText.filter(el => el !== null)
    TweenMax.set(intro, { y: "40", opacity: 0 })
    TweenMax.staggerTo(
      intro,
      0.5,
      { y: "0", opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.2
    )
  }

  showScene = () => {
    TweenMax.set(this.midground, { opacity: 0, x: -100 })
    TweenMax.set(this.foreground, { opacity: 0, x: -250 })
    TweenMax.set(this.background, { opacity: 0, x: -50 })
    TweenMax.to([this.background, this.midground, this.foreground], 1, {
      opacity: 1,
      ease: Cubic.easeOut,
      delay: 1
    })
    TweenMax.to(this.background, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.midground, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.foreground, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
  }

  render() {
    return (
      <ContentContainer innerRef={el => (this.container = el)}>
        <Titles>
          <TitleText innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.sweep.title" />
          </TitleText>
          <TitleDescription innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.sweep.intro" />
          </TitleDescription>
        </Titles>
        <Foreground innerRef={el => (this.foreground = el)}>
          <SVGLoader path={sweepForeground} width="100%" height="100%" />
        </Foreground>
        <Midground innerRef={el => (this.midground = el)}>
          <SVGLoader path={sweepMidground} width="100%" height="100%" />
        </Midground>
        <Background innerRef={el => (this.background = el)}>
          <SVGLoader path={sweepBackground} width="100%" height="100%" />
        </Background>
      </ContentContainer>
    )
  }
}

export default SweepView



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Sweep/index.js